import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    value:0
}

export const Counterslice = createSlice({
    name: 'counter',
    initialState,
    reducers:{
       
    }
})

export const {}= Counterslice.actions;

export default Counterslice.reducer